/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_None_OptionInputs */

const en_style_guide_none_option = /** @type {(inputs: Style_Guide_None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const fr_style_guide_none_option = /** @type {(inputs: Style_Guide_None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun`)
};

const de_style_guide_none_option = /** @type {(inputs: Style_Guide_None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keiner`)
};

const it_style_guide_none_option = /** @type {(inputs: Style_Guide_None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuno`)
};

const ru_style_guide_none_option = /** @type {(inputs: Style_Guide_None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Никто`)
};

const es_style_guide_none_option = /** @type {(inputs: Style_Guide_None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguno`)
};

const zh_cn2_style_guide_none_option = /** @type {(inputs: Style_Guide_None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有任何`)
};

const ja_style_guide_none_option = /** @type {(inputs: Style_Guide_None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なし`)
};

const hi_style_guide_none_option = /** @type {(inputs: Style_Guide_None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई नहीं`)
};

const pt_pt2_style_guide_none_option = /** @type {(inputs: Style_Guide_None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum`)
};

/**
* | output |
* | --- |
* | "None" |
*
* @param {Style_Guide_None_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_none_option = /** @type {((inputs?: Style_Guide_None_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_None_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_none_option(inputs)
	if (locale === "de") return de_style_guide_none_option(inputs)
	if (locale === "it") return it_style_guide_none_option(inputs)
	if (locale === "ru") return ru_style_guide_none_option(inputs)
	if (locale === "es") return es_style_guide_none_option(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_none_option(inputs)
	if (locale === "ja") return ja_style_guide_none_option(inputs)
	if (locale === "hi") return hi_style_guide_none_option(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_none_option(inputs)
	return en_style_guide_none_option(inputs)
});